import { useEffect, useState } from "react";
import { invokeCefSharpMethod } from "../services/cefSharpBinding";
import { bindHostObject } from "../services/hostObjectBinding";

export function useAccessibleModules(isReady: boolean): string[] {
    const [accessibleModules, setAccessibleModules] = useState<string[]>([]);

    useEffect(() => {
        if (!isReady) return;

        let cancelled = false;

        (async () => {
            try {
                const moduleAccessApi = await bindHostObject("moduleAccessApi");
                const raw = await invokeCefSharpMethod<string>(
                    "moduleAccessApi",
                    moduleAccessApi as Record<string, unknown>,
                    "getAccessibleModules",
                    [],
                );
                const moduleIds = JSON.parse(raw);

                if (!cancelled && Array.isArray(moduleIds)) {
                    setAccessibleModules(
                        moduleIds.filter(
                            (moduleId): moduleId is string => typeof moduleId === "string",
                        ),
                    );
                }
            } catch (error) {
                console.warn(
                    "[ModuleAccessAPI] Failed to load accessible modules:",
                    error,
                );
                if (!cancelled) setAccessibleModules([]);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [isReady]);

    return accessibleModules;
}
